import React, { useState } from "react"
import { Droppable } from "react-beautiful-dnd"
import RoadmapperEvent from "../RoadmapperEvent/RoadmapperEvent"

export default function RoadmapperDroppableContainer({
  eventIds,
  timeEvents,
  constraintEnd,
  constraintStart,
  isEditing,
  updateParentState,
  renderMoment,
  isBeingDragged,
  durationUnit,
  isDragDisabled,
  eventIdBeingEdited,
  updateEditEvent,
  deleteTimeEvent,
  values,
  skeletonLoader
}) {
  const [accumulatedTimes, updateAccumulatedTimes] = useState([])

  const changeSingleAccumulatedTime = (newTime, index) => {
    const tempArr = accumulatedTimes || 0
    tempArr[index] = newTime
    updateAccumulatedTimes(tempArr)
  }

  return (
    <div>
      <Droppable droppableId="TIME_EVENTS">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={styles.container}
          >
            {timeEvents && eventIds ? (
              eventIds
                .map((id) => {
                  // Find the event for this ID
                  const event = timeEvents.find((event) => event.id === id)
                  return event ? { id, event, index: -1 } : null
                })
                .filter((item) => item !== null) // Remove IDs that don't have corresponding events
                .map((item, index) => {
                  const { id, event } = item
                  // Calculate accumulated time
                  if (index !== 0) {
                    const prevEvent = timeEvents.find((e) => e.id === eventIds[index - 1])
                    if (prevEvent) {
                      changeSingleAccumulatedTime(
                        prevEvent.duration + (accumulatedTimes[index - 1] || 0),
                        index
                      )
                    }
                  }
                  return (
                    <RoadmapperEvent
                      skeletonLoader={skeletonLoader}
                      {...provided.droppableProps}
                      constraintStart={constraintStart}
                      constraintEnd={constraintEnd}
                      isEditing={isEditing}
                      updateParentState={updateParentState}
                      timeEvent={event}
                      key={event.id}
                      index={index}
                      isDragDisabled={isDragDisabled}
                      accumulatedTime={accumulatedTimes[index] || 0}
                      renderMoment={renderMoment}
                      isBeingDragged={isBeingDragged}
                      durationUnit={durationUnit}
                      updateEditEvent={updateEditEvent}
                      deleteTimeEvent={deleteTimeEvent}
                      values={values}
                      editingComponent={eventIdBeingEdited === event.id}
                    />
                  )
                })
            ) : (
              <></>
            )}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  )
}

const styles = {
  container: {
    maxWidth: "699px"
  }
}
